<div class="clinic-widget-container tcm-details-panel mb-4" *ngIf="viewModel">
  <div class="info-container">
    <div class="section logo">
      <div class="photo-wrapper">
        <img class="clinic-logo" src="{{viewModel.logo || '/assets/images/no-photo.jpg'}}" />
        <div class="upload-logo" *ngIf="canUpdatePhoto">
          <a href="#" oncontextmenu="return false;" (click)="openUplaodLogoModal($event)">
            {{'Screens.Clinics.InfoWidget.Update' | translate}}
          </a>
        </div>
      </div>
    </div>
    <div class="section info"></div>
    <div class="section contact-info">
      <span class="section-header">{{ viewModel.name }}</span>
      <hr />
      <div class="description">
        <div *ngIf="viewModel.contactPhones && viewModel.contactPhones.length > 0">
          {{'Screens.Clinics.InfoWidget.Phones' | translate}}: {{ contactPhones }}
        </div>
        <div *ngIf="viewModel.address">
          {{'Screens.Clinics.InfoWidget.Address' | translate}}: {{ viewModel.address }}
        </div>
      </div>
      <div class="description">
        <div *ngIf="systemPref.useObonoAPI">
          {{'Screens.Clinics.InfoWidget.IsObonoRegistered' | translate}}: {{ viewModel.isObonoRegistered ? 'YES' : 'NO' }}
          <span *ngIf="viewModel.isObonoRegistered"> | {{'Screens.Clinics.InfoWidget.ObonoExpirationDate' | translate}}: {{ viewModel.obonoExpirationDate | date }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
